export default __webpack_public_path__ + "static/media/central_management_number.734615e9.svg";